import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function VerifyEmailPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="card-elevated p-8 text-center">
          <div className="mx-auto w-16 h-16 bg-accent rounded-full flex items-center justify-center mb-4">
            <Mail className="h-8 w-8 text-accent-foreground" />
          </div>
          
          <h2 className="text-2xl font-semibold text-foreground mb-2">
            Verify Your Email
          </h2>
          
          <p className="text-muted-foreground mb-6">
            We've sent a verification link to your email address.
            Please check your inbox and click the link to verify your account.
          </p>

          <div className="space-y-3">
            <p className="text-sm text-muted-foreground">
              After verifying your email, you can sign in to access the platform.
            </p>
            
            <Link to="/login">
              <Button variant="outline" className="w-full">
                Back to Sign In
              </Button>
            </Link>
          </div>

          <div className="mt-6 pt-6 border-t border-border">
            <p className="text-xs text-muted-foreground">
              Didn't receive the email? Check your spam folder or contact support.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}